module.exports = "/_next/static/images/09a5499354c73195f1835f4a784fc829-hero-xs.jpg";